import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DatePicker, Form, Input, Select, Checkbox } from 'antd';

import locale from 'antd/es/date-picker/locale/ru_RU';

import CRUDE_City from '../../../objects/City/crude'
import REDUX_City from '../../../objects/City/reducer'
import REDUX_TipiMeropriyatii from '../../../objects/TipiMeropriyatii/reducer'
import REDUX_UrovenMeropriyatiya from '../../../objects/UrovenMeropriyatiya/reducer'
import { GET, POST, errorCatch } from 'fennec-ui';
import EmojiTextArea from '../../../common/EmojiTextArea';

const { Option } = Select;

export default function NovoeMeropriyatiya(props) {
    const { auth, object, form, sourceKey, ctx } = props;
    const dispatch = useDispatch();
    const city = useSelector(REDUX_City.selector.array);
    const tipMeropriyatiya = useSelector(REDUX_TipiMeropriyatii.selector.array);
    const urovenMeropriyatiya = useSelector(REDUX_UrovenMeropriyatiya.selector.array);

    // console.log(props);
    
    const [ekvairing, setEkvairing] = React.useState();
    useEffect(() => {
        POST(auth, '/api/nastroikiekvairinga/byorganizator', ctx, ({ data }) => {
            setEkvairing(data);
        }, errorCatch);
    }, [object]);
    const ekvairingOptions = ekvairing?.map((i, idx) => <Option key={i.ID} value={i.ID}>{i?.nastroiki?.nazvanie}</Option>);

    const defaultEkvairing = useCallback(()=>{
        if(ekvairing){
            let ispolzovatPoUmolchaniyu = ekvairing?.find(e=>e?.ekvairingOrganizatoraNastroikaEkvairinga?.find(ee=>ee?.ispolzovatPoUmolchaniyu==true))
            if(ispolzovatPoUmolchaniyu){
                return ispolzovatPoUmolchaniyu.ID
            }
            let osnovnoiDlyaSistemi = ekvairing?.find(e=>e?.nastroiki?.osnovnoiDlyaSistemi==true)
            if(osnovnoiDlyaSistemi){
                return osnovnoiDlyaSistemi.ID
            }
        }
        return undefined
    },[ekvairing]);

    useEffect(() => {
        form.resetFields();
        CRUDE_City.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_City.actions.setArray(data));
            }
        }, 'model', 's-id=ASC');
        GET(auth, '/api/tipimeropriyatii/' + sourceKey,
            ({ data }) => {
                dispatch(REDUX_TipiMeropriyatii.actions.setArray(data));
            },
            (err) => errorCatch(err));
        GET(auth, '/api/urovenmeropriyatiya/' + sourceKey,
            ({ data }) => {
                dispatch(REDUX_UrovenMeropriyatiya.actions.setArray(data));
            },
            (err) => errorCatch(err));
    }, []);
    const cityOptions = city.map((i) => <Option key={i.ID} value={i.ID}>{i.name}</Option>);
    const tipMeropriyatiyaOptions = tipMeropriyatiya.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    const urovenMeropriyatiyaOptions = urovenMeropriyatiya.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);

    return (
        <>
            {ekvairing && <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    nastroikaEkvairingaID: defaultEkvairing(),
                    // '@nachalo': (object) ? [object.nachaloSorevnovaniya, object.okonchanieSorevnovaniya] : undefined,
                    // '@kontrol': (object) ? [object.nachaloAdministrativnogoKontrolya, object.okonchanieAdministrativnogoKontrolya] : undefined
                }}
            >
                <Form.Item label="Название мероприятия"
                    name="nazvanieMeropriyatiya"
                    rules={[{ required: true, message: 'Пожалуйста, укажите название мероприятия!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Тип мероприятия"
                    name="tipMeropriyatiyaID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите тип мероприятия!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {tipMeropriyatiyaOptions}
                    </Select>
                </Form.Item>
                <Form.Item label="Уровень мероприятия"
                    name="urovenMeropriyatiyaID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите уровень мероприятия!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    // filterSort={(optionA, optionB) =>
                    //     optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                    // }
                    >
                        {urovenMeropriyatiyaOptions}
                    </Select>
                </Form.Item>
                <Form.Item label="Место проведения"
                    name="mestoProvedeniyaID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите город!' }]}
                >
                    <Select
                        placeholder="Город"
                        allowClear
                        showSearch
                        style={{ width: 200 }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {cityOptions}
                    </Select>
                </Form.Item>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                    <div style={{ padding: "0 5px", flexGrow: "1" }}>
                        <Form.Item
                            name={"nachaloRegistratsii"}
                            label={"Начало продажи билетов"}
                            tooltip={'До этого времени не будет БОЛЬШОЙ зеленой кнопки "Купить билет". Покупка билета до начала продаж ЗАПРЕЩЕНА!'}
                            rules={[{ required: true, message: 'Укажите время начала продажи билетов!' }]}
                        >
                            <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                        </Form.Item>
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                    <div style={{ padding: "0 5px", flexGrow: "1" }}>
                        <Form.Item
                            name={"nachaloSorevnovaniya"}
                            label={"Начало мероприятия"}
                            rules={[{ required: true, message: 'Укажите время начала мероприятия!' }]}
                        >
                            <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                        </Form.Item>
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                    <div style={{ padding: "0 5px", flexGrow: "1" }}>
                        <Form.Item
                            name={"okonchanieSorevnovaniya"}
                            label={"Окончание мероприятия"}
                            rules={[{ required: true, message: 'Укажите время окончания мероприятия!' }]}
                        >
                            <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                        </Form.Item>
                    </div>
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                    {ekvairing && <div style={{ flexBasis: "50%" }}>
                        <Form.Item label="Эквайринг"
                            name="nastroikaEkvairingaID"
                            rules={[{ required: true, message: 'Пожалуйста, укажите эквайринг!' }]}
                        >
                            <Select
                                // allowClear
                                showSearch
                                // style={{ width: 200 }}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.children?.toLowerCase().localeCompare(optionB.children?.toLowerCase())
                                }
                            >
                                {ekvairingOptions}
                            </Select>
                        </Form.Item>
                    </div>}
                    <div style={{ flexBasis: "50%" }}>

                    </div>
                </div>
            </Form>}
        </>
    );
}
